import React from 'react';
import { Link } from 'react-router-dom';
import { Newspaper } from 'lucide-react';
import { Separator } from '@/components/ui/separator';
import { Dialog, DialogContent, DialogTrigger, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import LegalDisclaimerContent from '@/components/LegalDisclaimerContent';

export default function Footer() {
  return (
    <footer className="border-t bg-card/50 mt-16 pb-20 lg:pb-0" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-7 h-7 bg-primary rounded-sm flex items-center justify-center">
                <Newspaper className="w-4 h-4 text-primary-foreground" />
              </div>
              <span className="font-display text-base font-bold">UMF Students Newspaper</span>
            </div>
            <p className="text-sm text-muted-foreground font-body leading-relaxed">
              Independent student newspaper. By students, for students.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-mono text-xs tracking-wider uppercase text-muted-foreground mb-3">Quick Links</h4>
            <div className="space-y-2">
              <Link to="/events" className="block text-sm font-body text-foreground hover:text-gold transition-colors">Events Calendar</Link>
              <Link to="/resources" className="block text-sm font-body text-foreground hover:text-gold transition-colors">Resource Library</Link>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-mono text-xs tracking-wider uppercase text-muted-foreground mb-3">Legal</h4>
            <div className="space-y-2">
              <Link to="/terms" className="block text-sm font-body text-foreground hover:text-gold transition-colors" data-testid="footer-terms-link">Terms and Conditions</Link>
              <Link to="/privacy" className="block text-sm font-body text-foreground hover:text-gold transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link>
              <Link to="/medical-disclaimer" className="block text-sm font-body text-foreground hover:text-gold transition-colors" data-testid="footer-medical-link">Medical Disclaimer</Link>
            </div>
          </div>
        </div>

        <Separator className="mb-6" />

        {/* Disclaimer */}
        <div className="max-w-5xl mx-auto space-y-4" data-testid="footer-disclaimer">
          <div className="text-center">
            <Dialog>
              <DialogTrigger className="text-sm font-body text-muted-foreground hover:text-gold transition-colors underline decoration-muted-foreground/30 underline-offset-4">
                Read Full Legal Disclaimer
              </DialogTrigger>
              <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
                <DialogHeader>
                  <DialogTitle>Full Legal Disclaimer</DialogTitle>
                </DialogHeader>
                <div className="mt-4">
                  <LegalDisclaimerContent />
                </div>
              </DialogContent>
            </Dialog>
          </div>
          <div className="mt-8 flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm font-body text-muted-foreground/80">
            <Link to="/about" className="hover:text-gold transition-colors">About Us</Link>
            <span className="hidden sm:inline-block text-muted-foreground/30">•</span>
            <Link to="/contact" className="hover:text-gold transition-colors">Contact</Link>
            <span className="hidden sm:inline-block text-muted-foreground/30">•</span>
            <Link to="/privacy" className="hover:text-gold transition-colors">Privacy Policy</Link>
            <span className="hidden sm:inline-block text-muted-foreground/30">•</span>
            <Link to="/terms" className="hover:text-gold transition-colors">Terms of Service</Link>
          </div>
          <div className="text-center mt-6">
            <p className="text-[10px] text-muted-foreground/60 font-mono">
              Copyright {new Date().getFullYear()} &copy; UMF Newspaper (independent)
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
